/**
 * Entry point for the React app: root element, router, and routes.
 * Included in src/index.html.
 */

import { createRoot } from "react-dom/client";
import App from "./App";

const elem = document.getElementById("root");
if (!elem) {
	throw new Error("Root element not found");
}

if (import.meta.hot) {
	if (!import.meta.hot.data.root) {
		import.meta.hot.data.root = createRoot(elem);
	}
	(import.meta.hot.data.root as ReturnType<typeof createRoot>).render(<App />);
} else {
	createRoot(elem).render(<App />);
}
